import { render } from "./admin-main.vue?vue&type=template&id=2579c5b1"
import script from "./admin-main.vue?vue&type=script&lang=js"
export * from "./admin-main.vue?vue&type=script&lang=js"

import "./admin-main.vue?vue&type=style&index=0&id=2579c5b1&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__